import React, { useState } from 'react';

import { RelativityListsModal } from './relativity-lists-dialog';
import { RelativityWorkspacesModal } from './relativity-workspaces-dialog';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { RelativityListType, RelativityWorkspaceType } from '@/api/types/backend-dto-types';

interface RelativityIntegrationModalProps {
  matterId?: string; // 2.0: matter-level
  caseId?: string; // Legacy: case-level
  onSelectList: (workspace: RelativityWorkspaceType, list: RelativityListType) => void;
  onClose: () => void;
}

type ModalStep = 'workspaces' | 'lists';

export const RelativityIntegrationModal: React.FC<RelativityIntegrationModalProps> = ({
  matterId,
  caseId,
  onSelectList,
  onClose,
}) => {
  const [currentStep, setCurrentStep] = useState<ModalStep>('workspaces');
  const [selectedWorkspace, setSelectedWorkspace] = useState<RelativityWorkspaceType | null>(null);
  const { data: matter } = useGetMatterV2(matterId);

  const handleSelectWorkspace = (workspace: RelativityWorkspaceType) => {
    setSelectedWorkspace(workspace);
    setCurrentStep('lists');
  };

  const handleSelectListComplete = (list: RelativityListType) => {
    if (selectedWorkspace) {
      onSelectList(selectedWorkspace, list);
    }
  };

  const handleBackToWorkspaces = () => {
    setCurrentStep('workspaces');
    setSelectedWorkspace(null);
  };

  if (currentStep === 'workspaces') {
    return (
      <RelativityWorkspacesModal
        onSelectWorkspace={handleSelectWorkspace}
        onClose={onClose}
        linkedWorkspaceId={matter?.relativityWorkspaceId ?? null}
      />
    );
  }

  if (currentStep === 'lists' && selectedWorkspace) {
    return (
      <RelativityListsModal
        workspace={selectedWorkspace}
        matterId={matterId}
        caseId={caseId}
        onSelectList={handleSelectListComplete}
        onBack={handleBackToWorkspaces}
        onClose={onClose}
      />
    );
  }

  return null;
};
